<section class="resource-overview">
  @if (resource(); as resource) {
    <div class="cui-title-bar">
      <span class="material-symbols-outlined">{{
        isToolResource ? 'widgets' : 'account_tree'
      }}</span>
      <h1>{{ getDisplayName(resource) }}</h1>
      <p>{{ resource.description }}</p>
    </div>
    <article class="cui-card information-card">
      <header class="cui-card__header">
        <span class="material-symbols-outlined">info</span> General Information
      </header>
      <dl>
        @if (isTool(resource)) {
          <div>
            <dt>Programming Language</dt>
            <dd>{{ resource.programLanguage }}</dd>
          </div>
        }
        <div>
          <dt>Created</dt>
          <dd>{{ formatDateTime(resource.created) }}</dd>
        </div>
        <div>
          <dt>Modified</dt>
          <dd>{{ formatDateTime(resource.modified) }}</dd>
        </div>
      </dl>
    </article>

    <div class="cui-action-bar">
      <a cuiButton [routerLink]="runLink">
        <span class="material-symbols-outlined">play_circle</span> Start New Job
      </a>
    </div>
  }

  <app-job-run-history
    [paginationStore]="runHistory"
    [emptyMessage]="
      isToolResource ? 'No tool runs yet.' : 'No toolchain runs yet.'
    "></app-job-run-history>
</section>
